export function categoryMeta(key: string): {
  label: string;
  avatar: string;
  tag: string;
} {
  switch (key) {
    case "whistle":
      return {
        label: "举报与揭发",
        avatar: "bg-primary-500 text-background-50",
        tag: "bg-primary-100 text-primary-700",
      };
    case "party":
      return {
        label: "涉事主角",
        avatar: "bg-accent-500 text-background-50",
        tag: "bg-accent-100 text-accent-900",
      };
    case "related":
      return {
        label: "关联当事人",
        avatar: "bg-secondary-500 text-background-50",
        tag: "bg-secondary-200 text-secondary-900",
      };
    case "progress":
      return {
        label: "回应与进展",
        avatar: "bg-foreground-800 text-background-50",
        tag: "bg-secondary-200 text-secondary-900",
      };
    default:
      return {
        label: "人物档案",
        avatar: "bg-secondary-500 text-background-50",
        tag: "bg-secondary-200 text-secondary-900",
      };
  }
}

export function categoryLabel(key: string): string {
  return categoryMeta(key).label;
}